import type { WidgetState, WidgetTransitionSource } from '@/domain/analytics';
import { WIDGET_STATES } from '@/domain/analytics';
import type { ServerConfiguration } from '@/domain/configuration';
import type { GoogleAnalyticsGateway } from '@/domain/gateway';
import type { WidgetEventName } from '@/domain/widgetEvent';
import GoogleAnalyticsGatewayImpl from '@/gateways/GoogleAnalyticsGateway';

export interface GoogleAnalyticsEventData {
  eventName: WidgetEventName;
  parameters: Record<string, unknown>;
}

export function createNoopGoogleAnalyticsGateway(): GoogleAnalyticsGateway {
  return { sendEvent: () => {}, setCustomTrackingId: () => {} };
}

export function createGoogleAnalyticsGateway(serverConfig: ServerConfiguration): GoogleAnalyticsGateway {
  const gaConfig = serverConfig.v2.behavior.gaConfiguration;

  if (!gaConfig?.enabled) {
    return createNoopGoogleAnalyticsGateway();
  }

  const gateway = new GoogleAnalyticsGatewayImpl();
  if (gaConfig.autoDetectTrackingId === false && gaConfig.gaTrackingId?.trim()) {
    gateway.setCustomTrackingId(gaConfig.gaTrackingId);
  }
  return gateway;
}

export function getWidgetViewChangedGoogleAnalyticsEvent(
  fromState: WidgetState,
  toState: WidgetState,
  source?: WidgetTransitionSource,
): GoogleAnalyticsEventData | null {
  const isOpening =
    (toState === WIDGET_STATES.MAXIMIZED || toState === WIDGET_STATES.SIDEBAR) &&
    fromState !== WIDGET_STATES.MAXIMIZED &&
    fromState !== WIDGET_STATES.SIDEBAR;

  if (isOpening) {
    return {
      eventName: 'sidekick:opened',
      parameters: source ? { source } : {},
    };
  }

  if (toState === WIDGET_STATES.BUBBLE) {
    return {
      eventName: 'sidekick:closed',
      parameters: {},
    };
  }

  return null;
}
